import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { borderStyleGray } from "../reportingHelpers";

export const OfficialCell = ({ role, name }) => (
  <View
    style={{
      flexDirection: "column",
      width: "100%",
      borderRight: borderStyleGray,
      borderBottom: borderStyleGray,
      padding: 2,
      height: 30,
      justifyContent: "space-between",
      fontSize: 10,
    }}
  >
    <Text style={{ fontSize: 8 }}>{role}</Text>
    <Text>{name}</Text>
  </View>
);

const safePrintName = (role) => role?.name ?? "-";

const Officials = ({ roles }) => {
  const findRole = (roleName) => roles.find((r) => r.role === roleName);

  const umpire1 = roles.find((r) => r.role === "UMPIRE" && r.number === 1);
  const umpire2 = roles.find((r) => r.role === "UMPIRE" && r.number === 2);
  const scoringJudge = findRole("JUDGE_SCORING");
  const technicalOfficer = findRole("TECHNICAL_OFFICIAL");
  const timingJudge = findRole("JUDGE_TIMING");
  const reserveUmpire = findRole("UMPIRE_RESERVE");
  return (
    <View
      style={{
        flexDirection: "row",
        marginTop: 6,
        borderLeft: borderStyleGray,
        borderTop: borderStyleGray,
      }}
    >
      <View style={{ flexBasis: "50%" }}>
        <OfficialCell role="Umpire" name={safePrintName(umpire1)} />
        <OfficialCell role="Scoring Judge" name={safePrintName(scoringJudge)} />
        <OfficialCell
          role="Technical Officer"
          name={safePrintName(technicalOfficer)}
        />
      </View>
      <View style={{ flexBasis: "50%" }}>
        <OfficialCell role="Umpire" name={safePrintName(umpire2)} />
        <OfficialCell role="Timing Judge" name={safePrintName(timingJudge)} />
        <OfficialCell
          role="Reserve Umpire"
          name={safePrintName(reserveUmpire)}
        />
      </View>
    </View>
  );
};

export default Officials;
